document.addEventListener('DOMContentLoaded', () => {
  const links = document.querySelectorAll('.download-link a');

  [...links].forEach(link => {
    link.setAttribute('download', '');
  });
});
